import React from 'react';
import {
  Container,
  Grid,
  makeStyles
} from '@material-ui/core';
import Page from '../../../components/Page';
import PreviewForm from './PreviewForm';

import parseUrl from '../../../utils/parseUrl';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  }
}));

const Account = () => {
  const classes = useStyles();

  const certificateId = parseUrl(3);

  return (
    <Page
      className={classes.root}
      title="Certificate Preview"
    >
      <Container maxWidth="lg">
        <Grid
          container
          spacing={3}
        >
          <PreviewForm urlCertificateId={certificateId} />
        </Grid>
      </Container>
    </Page>
  );
};

export default Account;
